import { environment } from 'environments/environment';
import { ICustomer } from '../../../models/customer.model';

export class ResourceUtil {
  private static API_USER_URL = environment.urlApi + 'api/user/{cId}';
  private static API_MODERATOR_URL = environment.urlApi + 'api/moderator/{cId}';
  private static API_ADMIN_URL = environment.urlApi + 'api/admin';

  public static asUserURL(fragment: string, customer: ICustomer | number): string {
    if (typeof customer === 'object') {
      return this.API_USER_URL.concat(fragment).replace('{cId}', '' + customer.id);
    } else {
      return this.API_USER_URL.concat(fragment).replace('{cId}', '' + customer);
    }
  }

  public static asModeratorURL(fragment: string, customer: ICustomer | number): string {
    if (typeof customer === 'object') {
      return this.API_MODERATOR_URL.concat(fragment).replace('{cId}', '' + customer.id);
    } else {
      return this.API_MODERATOR_URL.concat(fragment).replace('{cId}', '' + customer);
    }
  }

  public static asAdminURL(fragment: string, customer: ICustomer | number): string {
    if (typeof customer === 'object') {
      return this.API_ADMIN_URL.concat(fragment);
    } else {
      return this.API_ADMIN_URL.concat(fragment);
    }
  }
}
